
import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";
import TaskForm from "./TaskForm";
import { useTasks } from "@/context/TaskContext";

interface TaskEditModalProps {
  open: boolean;
  onClose: () => void;
}

export const TaskEditModal: React.FC<TaskEditModalProps> = ({ open, onClose }) => {
  const { taskToEdit, setTaskToEdit, updateTask } = useTasks();

  if (!taskToEdit) return null;

  const handleSave = async (title: string, detail: string) => {
    await updateTask({ ...taskToEdit, title, detail });
    setTaskToEdit(null);
    onClose();
  };

  const handleCancel = () => {
    setTaskToEdit(null);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleCancel(); }}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto bg-white dark:bg-white text-black">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          onClick={handleCancel}
          aria-label="Close"
          type="button"
        >
          <X />
        </button>
        <DialogTitle className="mb-6 text-2xl font-bold text-black w-full text-center">Edit Task</DialogTitle>
        <TaskForm onSave={handleSave} onCancel={handleCancel} taskToEdit={taskToEdit} isEditing={true} />
      </DialogContent>
    </Dialog>
  );
};

export default TaskEditModal;
